import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String }

  connect() {
    this.updateAnalyticsAttribute()

    this.observer = new MutationObserver(() => this.updateAnalyticsAttribute())
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ["class"]
    })
  }

  updateAnalyticsAttribute() {
    const isCollapse = this.element.classList.contains("fa-arrow-up")
    const action = isCollapse ? "collapse" : "expand"
    this.element.dataset.analyticsClick = `${this.nameValue}-${action}`
    console.log(this.element.dataset)
  }

  toggle() {
    this.updateAnalyticsAttribute()
  }
}
